import httpService from '../Api/http.service';
import { buildQuery, getApiBaseUrl } from 'utils';

const getEditorBaseUrl = () => `${getApiBaseUrl()}/appcore/editor/configs`;

// Editor Config Management

const getEditorConfigs = (level, levelId, editorProvider) => {
  const query = buildQuery({
    level,
    level_id: levelId,
    ...(editorProvider && { editor_provider: editorProvider }),
  });

  return httpService({
    url: `${getEditorBaseUrl()}${query}`,
    method: 'get',
  });
};

const getEditorConfig = (configId) => {
  // The list answers has_api_key false for every row — only this route
  // reads Parameter Store. Anything that needs to know whether a vendor
  // key is stored has to ask for the single config.
  return httpService({
    url: `${getEditorBaseUrl()}/${configId}`,
    method: 'get',
  });
};

// Same call shape as the rest of the module. Unlike SSO, this route
// validates level and level_id from the body, which is the service's
// business rather than the caller's.
const createEditorConfig = (level, levelId, payload) => {
  return httpService({
    url: getEditorBaseUrl(),
    method: 'post',
    data: { level, level_id: levelId, ...payload },
  });
};

const updateEditorConfig = (configId, payload) => {
  return httpService({
    url: `${getEditorBaseUrl()}/${configId}`,
    method: 'put',
    data: payload,
  });
};

const activateEditorConfig = (configId, isActive) => {
  return httpService({
    url: `${getEditorBaseUrl()}/${configId}/activate`,
    method: 'patch',
    data: { is_active: isActive },
  });
};

// Withdraws the vendor key and leaves the configuration working. Its
// own route because an absent field in an update means "leave it
// alone", so it cannot also mean "remove it".
const clearEditorApiKey = (configId) => {
  return httpService({
    url: `${getEditorBaseUrl()}/${configId}/api-key`,
    method: 'delete',
  });
};

const deleteEditorConfig = (configId) => {
  return httpService({
    url: `${getEditorBaseUrl()}/${configId}`,
    method: 'delete',
  });
};

const editorService = {
  getEditorConfigs,
  getEditorConfig,
  createEditorConfig,
  updateEditorConfig,
  activateEditorConfig,
  clearEditorApiKey,
  deleteEditorConfig,
};

export default editorService;
